import * as React from "react";
import { connect } from "react-redux";
import SearchInput, { createFilter } from "react-search-input";
import { AppShape } from "@eave/shared/types/api";
import Card from "../shared/Card";
import { updateSearchTerm } from "../../redux/searchLoans/actions";

const FontAwesome = require("react-fontawesome");
const styles = require("./styles.module.scss");

interface HomepageProps {
  apps: AppShape[];
  searchTerm: string;
  dispatch?: Function;
}

const KEYS_TO_FILTERS = ["loanid", "name", "email", "address", "loan_status", "loan_decision"];

const BorrowerInfo: React.SFC<{
  firstName: string;
  lastName: string;
  email?: string;
  phone?: string;
}> = ({ firstName, lastName, email, phone }) => (
  <div className={styles.borrower}>
    <div>{`${firstName} ${lastName}`}</div>
    {email && (
      <div>
        <strong>e: </strong>
        <a href={`mailto:${email}`}>{email}</a>
      </div>
    )}
    {phone && (
      <div>
        <strong>p: </strong>
        <a href={`tel:${phone}`}>{phone}</a>
      </div>
    )}
  </div>
);

class Homepage extends React.Component<HomepageProps, any> {
  constructor(props: HomepageProps) {
    super(props);
    this.state = {
      showAll: false,
    };
  }

  searchUpdated = term => {
    this.props.dispatch(updateSearchTerm(term));
  };

  render() {
    const { apps } = this.props;

    const filteredApps = apps
      .filter(createFilter(this.props.searchTerm.replace(/[^0-9a-z:]/gi, " "), KEYS_TO_FILTERS))
      .filter(app => !app.is_archived);

    return (
      <div className={styles.homepage}>
        <h1>Live Loans</h1>
        <div className={styles.searchBar}>
          <SearchInput
            fuzzy
            sortResults
            className={styles.searchInput}
            onChange={this.searchUpdated}
            caseSensitive={false}
            value={this.props.searchTerm}
            placeholder="Search by names, email, loan number, and address"
          />
        </div>
        <div className={styles.loanCards}>
          {filteredApps.map(app => (
            <Card key={app.id} className={styles.loanCard}>
              <h2>
                {app.borrower1_last_name}: {app.lead_number}
                {app.external_id && <> – {app.external_id}</>}
              </h2>
              <BorrowerInfo
                firstName={app.borrower1_first_name}
                lastName={app.borrower1_last_name}
                email={app.borrower1_email}
                phone={app.borrower1_phone}
              />
              {app.borrower2_first_name && (
                <BorrowerInfo
                  firstName={app.borrower2_first_name}
                  lastName={app.borrower2_last_name}
                  email={app.borrower2_email}
                  phone={app.borrower2_phone}
                />
              )}
              <div className={styles.footer}>
                <a href={`/loan-officer/app/${app.id}`}>
                  <FontAwesome name="arrow-right" size="2x" />
                </a>
              </div>
            </Card>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const searchTerm = state.operatorHomepage && state.operatorHomepage.homepageSearchTerm;
  const apps = state.operatorHomepage && state.operatorHomepage.searchData;
  return {
    apps,
    searchTerm,
  };
};

export default connect<any, any, any>(mapStateToProps)(Homepage);
